export default __webpack_public_path__ + "static/media/validasi-kepala-finance.816ba888.png";